




















































































































import { Component, Vue, Mixins } from 'vue-property-decorator';
import UserMethods from '@/mixins/UserMethods.vue';
import { Mutations, Views, ViewModes } from '@/ts/store/Constants';
import MobileUserInfoConnectedUsers from './MobileUserInfoConnectedUsers.vue';
import MobileUserAttachment from './MobileUserAttachment.vue';
import MobileUserEditInfo from '@/components/User/MobileUserEditInfo.vue';

@Component({
    components: {
        MobileUserInfoConnectedUsers,
        MobileUserAttachment,
        MobileUserEditInfo,
    },
})
export default class MobileUserInfo extends Mixins(UserMethods) {

    public created() {
        this.$store.commit(Mutations.SET_VIEW, {
            view: Views.Profile,
            viewMode: ViewModes.Profile.Profile,
        });
    }

    public beforeCreate() {
        this.$store.commit(Mutations.SET_HEADER_TEXT, Vue.i18n.translate('header.profile', 'Profile'));
        this.$store.commit(Mutations.SET_RIGHT_HEADER_BUTTON, 'HococoEditButton');
        this.$store.commit(Mutations.SET_LEFT_HEADER_BUTTON, 'BackButton');
    }

    get view() {
        return this.$store.getters['Viewport/getCurrentView'];
    }

    get profileView() {
        return (this.view.viewMode === ViewModes.Profile.Profile);
    }

    get attachmentView() {
        return (this.view.viewMode === ViewModes.Profile.Attachment);
    }

    get editProfile() {
        return (this.view.viewMode === ViewModes.Profile.EditProfile);
    }

    public goToAttachment() {
        this.$store.commit(Mutations.SET_VIEW, {
            view: Views.Profile,
            viewMode: ViewModes.Profile.Attachment,
        });
    }
}

